import applicantInfoProps from '../applicants/info_properties';

const info_properties = {
  viewed: {
    type: 'string',
    nullable: true,
  },
  notificationSendDate: {
    type: 'string',
    nullable: true,
  },
  createdBy: {
    type: 'string',
    nullable: true,
  },
  applicantInfo: { type: 'object', properties: applicantInfoProps },
};

export default info_properties;
